import { ExtensionsRegistryHost } from '@wix/extensions-registry-host';

export const registryHost = new ExtensionsRegistryHost({
  manifestURL:
    'https://editor.wix.com/_serverless/editor-platform-registry-manifest',
});
